import { useRuntimeStore } from '@/store/useRuntimeStore'

type UnauthorizedHandler = () => void
type ClientTokenRefreshHandler = () => Promise<boolean>

let unauthorizedHandler: UnauthorizedHandler | null = null
let clientTokenRefreshHandler: ClientTokenRefreshHandler = async () => false

/** 并发 401 合并成一次宿主续期（对齐 org-console）。 */
let clientRefreshInFlight: Promise<boolean> | null = null

export function setUnauthorizedHandler(next: UnauthorizedHandler | null) {
  unauthorizedHandler = next
}

export function setClientTokenRefreshHandler(fn: ClientTokenRefreshHandler) {
  clientTokenRefreshHandler = fn
}

export function notifyUnauthorized() {
  unauthorizedHandler?.()
}

function refreshClientTokenOnce(): Promise<boolean> {
  if (!clientRefreshInFlight) {
    clientRefreshInFlight = clientTokenRefreshHandler().finally(() => {
      clientRefreshInFlight = null
    })
  }
  return clientRefreshInFlight
}

/**
 * 401 处理（对齐 org axios 拦截器）：
 * - 浏览器 → 未登录回调（logout + /login）
 * - 客户端 → 单飞续 JWT 后由调用方重试原请求 1 次；再 401 / 续失败 → 未登录回调（不跳 /login）
 *
 * @returns `'retry'` 表示应带着新 token 再发一次；`'reject'` 表示把当前 401 交给上层抛错。
 */
export async function resolveUnauthorized(authRetried: boolean): Promise<'retry' | 'reject'> {
  if (!useRuntimeStore.getState().isClient) {
    notifyUnauthorized()
    return 'reject'
  }
  if (authRetried) {
    notifyUnauthorized()
    return 'reject'
  }
  const refreshed = await refreshClientTokenOnce()
  if (!refreshed) {
    notifyUnauthorized()
    return 'reject'
  }
  return 'retry'
}
